export default "__VITE_ASSET__$$e1hPbTARmLZxiCV0vVfA__"